export const PERCENT_MULTIPLIER = 100;

export const HEALTH_ROUTE = '/internal-admin/health';
